<template>
  <div class="yisou">
    <div class="yisoubg">
      <appHeader activeIndex="yisou" ></appHeader>
      <div class="yisouContent">
        <!-- 介绍 -->
        <div class="yisouInfo">
          <div class="yisouInfo1">
            <img class="yisouInfo1Img1" src="../../assets/img/Product/yisou.png"  alt />
            <!-- <img class="yisouInfo1Img2"  src="../../assets/img/products/yisou/yisouQRcode.png" alt /> -->
          </div>
          <div class="yisouInfo2">
            <img src="../../assets/img/products/yisou/yisouFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>海量热门小说尽在易搜小说！玄幻、仙侠、穿越、言情、修真、悬疑、异能等等精选分类！</p>
             <p>贴心一键加入书架，让您追书更省心。</p>
             <p>整合多平台书目，丰富的资源供您阅读，网络小说热门排行，专业书单推荐，让您更容易发现自己喜爱的内容</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="yisouCarousel">
          <!-- <h2>功能特点</h2> -->
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="yisouWrap">
            <div class="yisouMainImg" :style="{ left: nowLeft + '%' }">
              <img class="yisouCarouselImg"   src="../../assets/img/products/yisou/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
     left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/yisou.css";
</style>
